import axios from 'axios';

import { X_TENANT_ID_HEADER } from '@packages/shared-utils';

import { getAccessToken } from '@/services/authStorage';
import { getImpersonatedTenantId } from '@/services/impersonationContext';

const API_BASE_URL =
  import.meta.env.VITE_API_URL ?? 'http://localhost:3000';

export const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = getAccessToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  const impersonatedTenantId = getImpersonatedTenantId();
  if (impersonatedTenantId) {
    config.headers[X_TENANT_ID_HEADER] = impersonatedTenantId;
  }
  return config;
});
